/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestMetricTargetUpdate } from '../../models/harvest-metric-target-update';
import { HarvestMetricTargetUpdateResponse } from '../../models/harvest-metric-target-update-response';
import { HarvestSex } from '../../models/harvest-sex';

export interface UpdateTargets$Params {
  brandName: string;
  harvestSex: HarvestSex;
      body: HarvestMetricTargetUpdate
}

export function updateTargets(http: HttpClient, rootUrl: string, params: UpdateTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestMetricTargetUpdateResponse>> {
  const rb = new RequestBuilder(rootUrl, updateTargets.PATH, 'put');
  if (params) {
    rb.path('brandName', params.brandName, {});
    rb.path('harvestSex', params.harvestSex, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestMetricTargetUpdateResponse>;
    })
  );
}

updateTargets.PATH = '/api/metric-target/update/{brandName}/{harvestSex}';
